import { JumboTabs, TabBar } from "antd-mobile";
import { useAuth, useTranslateContext } from "fennec-ui";
import Icofont from "react-icofont";
import { useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router";
import { level } from "../../../common/Tool";

export default function MenuLevelTwo({ menu }) {
    const auth = useAuth();
    let navigate = useNavigate();
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    let _menu = level(menu, "", role_by_id)

    let match = useMatch({
        path: "/app/:one/:two",
        caseSensitive: false,
        end: false
    })
    const elements = _menu.map((element, index) => {
        const key = element.uuid || element.key || index;
        const count = (element.badge) ? element.badge(element).count : 0;
        const icon = (element.icon) ? element.icon(element) : undefined;
        const iconselected = (element.iconselected) ? element.iconselected(element) : undefined;
        return (
            <TabBar.Item
                icon={(icon) ? icon : <Icofont icon="file-fill" style={{ fontSize: "20px" }} />}
                selectedIcon={(iconselected) ? iconselected : <Icofont icon="file-fill" style={{ fontSize: "20px", color: "white" }} />}
                title={<span style={{ color: (key === match?.params?.two) ? "white" : "rgb(148, 148, 148)" }}>{element.name}</span>}
                key={key}
                badge={(count > 0) ? count : ""}
            >
            </TabBar.Item>
        )
    })
    const change = (key) => {
        navigate(key);
    }
    return (
        <TabBar
            className={"menu-level-two"}
            hidden={_menu.length < 2}
            onChange={change}
            activeKey={match?.params?.two}
        >
            {elements}
        </TabBar>
    )
}

export const statusForHeader = (status) => {
	return status.filter((s) => {
		if (s.tipNovayaInfa == false) return false;
		return true;
	})
};
export const notifyForHeader = (notify) => {
	return notify.filter((s) => {
		if (s.prochitano == true) return false;
		return true;
	})
};
